module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img14.081f7d81.jpg";